import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 text-center mb-2">
          Explore Product Categories
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-8 max-w-xl mx-auto">
          Browse our curated spreadsheet collections across every category — each with verified product links ready for your shopping agent.
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-2 p-4 md:p-5 bg-background-50 border border-foreground-200 rounded-lg hover:border-primary-300 hover:bg-primary-50/60 transition-all duration-200 cursor-pointer"
            >
              <span className="w-10 h-10 flex items-center justify-center">
                <i className={`${cat.icon} text-xl text-primary-500 group-hover:text-primary-600 transition-colors duration-200`}></i>
              </span>
              <span className="text-xs md:text-sm text-foreground-700 text-center font-medium whitespace-nowrap">
                {cat.name}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}